import { FileText, Trash2 } from 'lucide-react';
import useConfirmationDialog from '@/hooks/useConfirmationModal';
import { cn } from '@/lib/utils';
import { useCourseLessonsStore } from '@/stores/lessonStore';

interface LessonPlanEntryProps {
	lesson: Lesson;
	isActive: boolean;
	groupId: string;
}

const LessonPlanEntry = ({ lesson, isActive, groupId }: LessonPlanEntryProps) => {
	const { removeLesson, setActiveLesson, activeLessonId } = useCourseLessonsStore();
	const isLessonActive = isActive && lesson.id === activeLessonId;

	const confirm = useConfirmationDialog({
		message: 'Are you sure you want to delete this lesson?',
		onConfirm: () => removeLesson(groupId, lesson.id),
		onCancel: () => null,
	});

	return (
		<>
			{confirm.Dialog()}
			<div
				className={cn(
					'group/row flex items-center gap-1 rounded-md px-2 py-1.5 transition-colors',
					isLessonActive
						? 'bg-primary/10 text-primary'
						: 'text-muted-foreground hover:bg-accent hover:text-foreground'
				)}
			>
				<button
					type="button"
					onClick={() => setActiveLesson(lesson.id)}
					className="flex flex-1 items-center gap-1.5 min-w-0 text-left"
				>
					<FileText size={18} className="shrink-0 opacity-70" />
					<span className="truncate text-sm leading-none">{lesson.title || 'New Lesson'}</span>
				</button>
				<button
					type="button"
					aria-label="Delete lesson"
					onClick={() => confirm.onOpen(lesson.id)}
					className="shrink-0 opacity-0 group-hover/row:opacity-100 flex items-center justify-center h-5 w-5 rounded text-muted-foreground hover:text-destructive hover:bg-destructive/10 transition-all"
				>
					<Trash2 size={18} />
				</button>
			</div>
		</>
	);
};

export default LessonPlanEntry;
